import React from 'react';
import styled from 'styled-components/macro';
import translate from '../TranslateHOC';
import errorIcon from '../../img/icons/error_red.svg';

function LoadingError({ errorMessage }) {
  return <Error>{errorMessage}</Error>;
}

const Error = styled.div`
  background: ${(props) => props.theme.color.white};
  border-radius: 8px;
  color: #494948;
  font-size: 18px;
  overflow: hidden;
  padding: 2em 2em 2em 4em;
  position: relative;
  margin: 1em 0 2em;
  max-width: 800px;
  @media screen and (min-width: 768px) {
    margin-left: 0;
    margin-right: 0;
    width: 80%;
  }
  &:before {
    background: url(${errorIcon}) no-repeat top left;
    content: '';
    display: block;
    height: 36px;
    left: 1em;
    position: absolute;
    top: 26px;
    width: 36px;
  }
  &:after {
    background: #d63d45;
    bottom: 0;
    content: '';
    display: block;
    left: 0;
    position: absolute;
    width: 4px;
    top: 0;
  }
`;

export default translate(LoadingError);
